import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Model from 'flarum/common/Model';
export function formatShieldUrl(escudo) {
  if (!escudo || typeof escudo !== 'string') return null;
  const trimmed = escudo.trim();
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://') || trimmed.startsWith('//') || trimmed.startsWith('/')) {
    return trimmed;
  }
  return '/assets/extensions/nagusi-match-ratings/escudos/' + trimmed;
}
export default class Rival extends Model {
  constructor() {
    super(...arguments);
    _defineProperty(this, "name", Model.attribute('name'));
    _defineProperty(this, "escudo", Model.attribute('escudo'));
    _defineProperty(this, "division", Model.attribute('division'));
    _defineProperty(this, "createdAt", Model.attribute('createdAt', Model.transformDate));
  }
  escudoUrl() {
    return formatShieldUrl(this.escudo());
  }
}
flarum.reg.add('nagusi-match-ratings', 'common/models/Rival', Rival);